import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@jarvis/react-portal-addons';
import { IconCheckmarkCircle } from '@veneer/core';
import primitives from '@veneer/primitives';
import {
  CardBody, CardContainer, ContentContainer, Description, Footer, HeaderContainer, HeaderText, Image, Title,
} from './styles';

const SolutionCardTemplate = props => {
  const {
    headerText,
    title,
    description,
    icon,
    footerText,
    footerHyperlink,
    onClick = null,
    dataTestIds,
    showCheckmarkCircleIcon = false,
  } = props;

  return (
    <CardBody
      data-testid={dataTestIds.card}
      border="dropShadow"
      content={(
        <CardContainer>
          <HeaderContainer>
            { showCheckmarkCircleIcon && (
              <IconCheckmarkCircle
                filled
                size={20}
                customStyle={{
                  color: primitives.color.green7,
                }}
              />
            )}

            <HeaderText
              className="caption-regular"
              tagReplaceStart="<span class='caption-regular'>"
              tagReplaceEnd="</span>"
              data-testid={dataTestIds.header}
              text={headerText}
            />
          </HeaderContainer>
          <ContentContainer>
            <Title
              className="subtitle-large"
              data-testid={dataTestIds.title}
            >
              {title}
            </Title>
            <Image src={icon} alt="card-icon" />
            <Description
              className="caption-regular"
              data-testid={dataTestIds.description}
            >
              {description}
            </Description>
            <Footer>
              <Link
                className="label-regular" href={footerHyperlink}
                data-testid={dataTestIds.link}
                target="_blank"
                windowFeatures="noopener,noreferrer"
                onClick={onClick}
              >
                {footerText}
              </Link>
            </Footer>
          </ContentContainer>
        </CardContainer>
      )}
    />
  );
};

SolutionCardTemplate.defaultProps = {
  onClick: null,
  footerHyperlink: '',
  showCheckmarkCircleIcon: false,
};

SolutionCardTemplate.propTypes = {
  headerText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  footerHyperlink: PropTypes.string,
  footerText: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  dataTestIds: PropTypes.shape({
    card: PropTypes.string,
    header: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
  }).isRequired,
  showCheckmarkCircleIcon: PropTypes.bool,
};

export default SolutionCardTemplate;
